"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var ArrayControl_1 = require("./ArrayControl");
var util_1 = require("../../util");
var ArrayControlRenderer = function (_a) {
    var schema = _a.schema, uischema = _a.uischema, data = _a.data, path = _a.path, rootSchema = _a.rootSchema, uischemas = _a.uischemas, addItem = _a.addItem, getStyle = _a.getStyle, getStyleAsClassName = _a.getStyleAsClassName, removeItems = _a.removeItems, id = _a.id, visible = _a.visible, enabled = _a.enabled, errors = _a.errors;
    var controlElement = uischema;
    var labelDescription = core_1.Helpers.createLabelDescriptionFrom(controlElement, schema);
    var label = labelDescription.show ? labelDescription.text : '';
    var controlClassName = "control " + (core_1.Helpers.convertToValidClassName(controlElement.scope));
    var fieldSetClassName = getStyleAsClassName('array.layout');
    var buttonClassName = getStyleAsClassName('array.button');
    var childrenClassName = getStyleAsClassName('array.children');
    var classNames = {
        wrapper: controlClassName,
        fieldSet: fieldSetClassName,
        button: buttonClassName,
        children: childrenClassName
    };
    return (react_1.default.createElement(ArrayControl_1.ArrayControl, { errors: errors, getStyle: getStyle, getStyleAsClassName: getStyleAsClassName, removeItems: removeItems, classNames: classNames, data: data, label: label, path: path, addItem: addItem, uischemas: uischemas, uischema: uischema, schema: schema, rootSchema: rootSchema, id: id, visible: visible, enabled: enabled }));
};
exports.default = util_1.withVanillaControlProps(react_2.withJsonFormsArrayControlProps(ArrayControlRenderer));
//# sourceMappingURL=ArrayControlRenderer.js.map